import { createClient } from '@supabase/supabase-js'

const supabase = createClient(
  process.env.REACT_APP_SB_URL,
  process.env.REACT_APP_SB_KEY
)

export default supabase
